<template>
  <div class="template-corporation">
    <div class="sr2-wrap-back-btn">
      <back-button
        style="margin-bottom: 16px; margin-top: 23px"
        class="desktop-padding"
        caption="ย้อนกลับ"
      />
    </div>
    <div class="body-capture" ref="captureMe">
      <!-- <div class="sr2-body">
        <div class="sr2-knowledge">
          <div class="col-img">
            <img src="@/assets/images/Vector.png" alt="knowledge" />
          </div>
          <div class="col-content-knowledge">
            <slot name="info-contents" />
          </div>
        </div>
      </div>
      -->
      <img class="sr2bb-img" :src="corpPNG" alt="job" />
      <div v-if="hasFinalTaxType" class="summary-tax">
        โดยปีนี้คุณจะเสียภาษีประมาณ {{ tax }} บาท
      </div>
      <div class="row-content-knowledge">
        <div class="title">
          <h2>หน้าที่ของนิติบุคคล</h2>
        </div>
        <div class="contents">
          <span>1. </span>
          <span class="wld-link">
            จดทะเบียนนิติบุคคล ซึ่งสามารถจดออนไลน์
            <span class="underline" @click="goERegist">
              ได้ที่นี่<img
                class="crll-img"
                :src="EXTERNALICON"
                alt="externalicon"
            /></span>
          </span>
        </div>
        <div class="contents">
          <span>2. </span>
          <span class="wld-link">
            ขึ้นทะเบียนลูกจ้างเป็นผู้ประกันตน ซึ่งสามารถทำผ่านระบบออนไลน์
            <span class="underline" @click="goSsoOnline">
              ได้ที่นี่<img
                class="crll-img"
                :src="EXTERNALICON"
                alt="externalicon"
            /></span>
          </span>
        </div>
      </div>
      <slot name="info-contents" />

      <div
        class="row-content-knowledge"
        v-if="showBusiness"
        style="margin-bottom: 55px"
      >
        <div class="title">
          <h2>หน้าที่ของ<br />ผู้ประกอบการจด VAT</h2>
        </div>
        <div class="contents">
          <span>1. </span>
          <span class="wld-link"
            >จัดทำใบกำกับภาษี โดยออกทุกครั้งเมื่อขายสินค้า
            หรือให้บริการและเกิดจุดความรับผิดทางด้านภาษี เช่น ขายสินค้า = ส่งมอบ
            หรือบริการ = ชำระเงิน
          </span>
        </div>
        <div class="contents">
          <span>2. </span>
          <span class="wld-link">
            จัดทำรายงานที่เกี่ยวข้อง รายงานภาษีซื้อ รายงาน ภาษีขาย และ
            รายงานสินค้าคงเหลือและวัตถุดิบ
          </span>
        </div>
        <div class="contents">
          <span>3. </span>
          <span class="wld-link">
            นำยอดภาษีขาย มาหักด้วยภาษีซื้อ (ที่จ่ายไป)
            และนำส่งภาษีมูลค่าเพิ่มด้วย
            <span @click="goToDoc30" class="underline"
              >แบบแสดงรายการสรุปภาษีซื้อขาย<img
                class="crll-img"
                :src="EXTERNALICON"
                alt="externalicon"
            /></span>
            ในทุกเดือนภายในวันที่ 15 ของเดือนถัดไป (อาจมีขยายเวลาบางกรณี)
          </span>
        </div>
        <div class="contents">
          <span>4. </span>
          <span class="wld-link">
            จัดทำบัญชี/งบการเงินเพื่อนำส่งต่อ<span class="bold"
              >กรมพัฒนาธุรกิจการค้า</span
            >
            โดยสามารถดาวน์โหลดโปรแกรม บัญชีสำหรับผู้ประกอบการ
            <span @click="cloudAccounting" class="underline"
              >ได้ที่นี่<img
                class="crll-img"
                :src="EXTERNALICON"
                alt="externalicon"
            /></span>
          </span>
        </div>
        <div class="contents">
          <span>5. </span>
          <span class="wld-link">
            เพื่อความสะดวกในการเสียภาษี เราแนะนำให้ สมัครยื่นเสียภาษีผ่านระบบ
            <span @click="eFiling" class="underline"
              >e-Filing<img
                class="crll-img"
                :src="EXTERNALICON"
                alt="externalicon"
            /></span>
          </span>
        </div>
        <slot name="to-do" />
      </div>
      <div class="row-content-knowledge" v-else>
        <div class="title">
          <h2>ช่วงเวลาคุณต้องติดต่อ <br />ยื่นเอกสารกับสรรพากร</h2>
        </div>
      </div>

      <div class="sr2b-body">
        <div>
          <div class="sr2bbbw-title">
            <img :src="CALENDARINDEX" class="img-title" />ยื่นทุกเดือน
          </div>
          <div class="calendar-card">
            <div class="calendar-img">
              <img :src="CARLENDAR.SEVENTH" alt="SEVENTH" />
            </div>
            <div class="calendar-detail">
              <span class="bold"
                ><img
                  :src="BUILDING"
                  class="img-title"
                />ยื่นแบบเองที่สรรพากร</span
              >
              <span @click="goToDoc1" class="underline"
                >แจ้งรายได้พนักงาน<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
              <span @click="goToDoc3" class="underline"
                >แจ้งภาษีหัก ณ ที่จ่าย<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
              <span @click="goToDoc53" class="underline"
                >แจ้งภาษีหัก ณ ที่จ่ายนิติบุคคล<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
            </div>
          </div>
          <div class="calendar-card" v-if="showBusiness">
            <div class="calendar-img">
              <img :src="CARLENDAR.FIFTEENTH" alt="FIFTEENTH" />
            </div>
            <div class="calendar-detail">
              <span class="bold"
                ><img
                  :src="BUILDING"
                  class="img-title"
                />ยื่นแบบเองที่สรรพากร</span
              >
              <span @click="goToDoc30" class="underline"
                >แสดงรายการสรุปภาษีซื้อขาย<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon" /></span
              ><br />
              <span class="bold"
                ><img :src="NOTEBOOK" class="img-title" />ยื่นแบบออนไลน์</span
              >
              <span @click="goToDoc1" class="underline"
                >แจ้งรายได้พนักงาน<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
              <span @click="goToDoc3" class="underline"
                >แจ้งภาษีหัก ณ ที่จ่าย<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon" /></span
              ><span @click="goToDoc53" class="underline"
                >แจ้งภาษีหัก ณ ที่จ่ายนิติบุคคล<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
            </div>
          </div>
          <div class="calendar-card" v-else>
            <div class="calendar-img">
              <img :src="CARLENDAR.FIFTEENTH" alt="FIFTEENTH" />
            </div>
            <div class="calendar-detail">
              <span class="bold"
                ><img
                  :src="BUILDING"
                  class="img-title"
                />ยื่นแบบเองที่สรรพากร</span
              >
              <span @click="goToDoc30" class="underline"
                >แสดงรายการสรุปภาษีซื้อขาย<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon" /></span
              ><br />
              <span class="bold"
                ><img :src="NOTEBOOK" class="img-title" />ยื่นแบบออนไลน์</span
              >
              <span @click="goToDoc1" class="underline"
                >แจ้งรายได้พนักงาน<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
              <span @click="goToDoc3" class="underline"
                >แจ้งภาษีหัก ณ ที่จ่าย<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
            </div>
          </div>

          <div class="calendar-card" v-if="showBusiness">
            <div class="calendar-img">
              <img :src="CARLENDAR.TWENTYTHIRD" alt="TWENTYTHIRD" />
            </div>
            <div class="calendar-detail">
              <span class="bold"
                ><img :src="NOTEBOOK" class="img-title" />ยื่นแบบออนไลน์</span
              >
              <span @click="goToDoc30" class="underline"
                >แสดงรายการสรุปภาษีซื้อขาย<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
            </div>
          </div>
        </div>
        <div>
          <div class="sr2bbbw-title">
            <img :src="CALENDARINDEX" class="img-title" />ยื่นทุกปี
          </div>
          <div class="calendar-card">
            <div class="calendar-img">
              <img :src="CARLENDAR.FEB" alt="FEB" />
            </div>
            <div class="calendar-detail">
              <span class="bold"
                ><img
                  :src="BUILDING"
                  class="img-title"
                />ยื่นแบบภายในสิ้นเดือน</span
              >
              <span @click="goToDoc1a" class="underline"
                >แจ้งรายได้พนักงานรอบรายปี<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
            </div>
          </div>
          <div class="calendar-card">
            <div class="calendar-img">
              <img :src="CARLENDAR.MAY" alt="MAR" />
            </div>
            <div class="calendar-detail">
              <span class="bold"
                ><img :src="BUILDING" class="img-title" />ยื่นแบบภายใน 150
                วันนับแต่วัน สุดท้ายของรอบระยะเวลาบัญชี</span
              >
              <span @click="goToDoc50" class="underline"
                >ภาษีเงินได้นิติบุคคล<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
            </div>
          </div>
          <div class="calendar-card">
            <div class="calendar-img">
              <img :src="CARLENDAR.AUG" alt="APR" />
            </div>
            <div class="calendar-detail">
              <span class="bold"
                ><img :src="BUILDING" class="img-title" />ยื่นแบบภายใน 2
                เดือนนับแต่วัน สุดท้ายของรอบระยะ 6 เดือน</span
              >
              <span @click="goToDoc51" class="underline"
                >ภาษีเงินได้นิติบุคคลครึ่งปี<img
                  class="crll-img"
                  :src="EXTERNALICON"
                  alt="externalicon"
              /></span>
            </div>
          </div>

          <chevron-right-link
            @clickLink="goDocumentsCorp"
            style="margin-bottom: 40px"
            class="link-desktop"
            caption="แบบฟอร์มแต่ละแบบคืออะไร"
          />
        </div>
      </div>

      <div class="sticky-button" id="sticky-btn" v-if="!hasFinalTaxType">
        <div class="label-btn-sticky">
          ถ้ายังไม่แน่ใจว่าคุณเหมาะจะเป็นผู้ประกอบการประเภทไหน
          <b>ลองเปรียบเทียบดูไหม?</b>
        </div>
        <material-button
          class="psb-button btn-sticky"
          style="margin-bottom: 16px"
          @clickButton="goIncome"
        >
          เปรียบเทียบภาษีเงินได้บุคคลธรรมดาและนิติบุคคล
        </material-button>
      </div>
      <div class="wrap-btn">
        <material-button
          class="psb-button"
          :class="[hasFinalTaxType ? '' : 'button-secondary']"
          style="margin-bottom: 40px"
          @clickButton="playAgain"
        >
          กลับไปเริ่มเล่นใหม่
        </material-button>
      </div>
      <div class="content-knowledge" v-if="fact">
        <div class="title">
          <h2>ข้อควรรู้</h2>
        </div>
        <div class="contents" v-for="(item, index) in fact" :key="index">
          <span>&#8226;</span>
          <span class="wld-link">
            {{ item }}
          </span>
        </div>
      </div>
      <div class="content-knowledge" v-if="penalty">
        <div class="title penalty">
          <h2>ข้อพึงระวัง</h2>
        </div>
        <div class="contents" v-for="(item, index) in penalty" :key="index">
          <span>&#8226;</span>
          <span class="wld-link">
            {{ item }}
          </span>
        </div>
      </div>
    </div>

    <div class="sr2-footer">
      <div class="sr2f-row">เกี่ยวกับเรา</div>
      <chevron-right-link
        @clickLink="goRateUs"
        class="desktop-size"
        style="margin-bottom: 9px; justify-content: flex-start"
        caption="ให้คะแนนและข้อเสนอแนะ"
      />

      <div class="sr2f-row" style="margin-top: 24px">
        ชอบเว็บนี้? แชร์ให้เพื่อนมาลองเล่นเลย
      </div>
      <social-sharing />
    </div>

    <div class="sr2-footer-blue sr2-blue-background">
      <div class="sr2fb-body">
        <div>ส่งผลลัพธ์ไปที่อีเมลของคุณ</div>

        <div class="sr2fbb-form">
          <input
            class="sr2fbbf-input"
            placeholder="กรุณากรอกอีเมล"
            v-model="email"
            :disabled="sending"
          />
          <material-button
            class="sr2fbbf-button"
            :disabled="!isEmailValid || sending"
            @clickButton="sendResultToEmail"
            id="send-email"
          >
            <loading v-if="sending" />
            <span v-else>ส่ง</span>
          </material-button>
        </div>
      </div>
    </div>
    <modal v-if="isOpenModal">
      <div slot="body">
        <img
          :src="VECTOR"
          class="img-vector"
          style="margin-top: 20px; margin-bottom: 30px"
        />
        <div class="red-modal" style="margin-bottom: 10px">
          <div>จากลักษณะธุรกิจของคุณเราแนะนำ</div>
          ให้จดทะเบียนภาษีมูลค่าเพิ่ม (VAT)
        </div>
        <div class="break">
          <div>เพื่อหลีกเลี่ยงค่าใช้จ่ายเพิ่มเติมที่เกิดจากเบี้ยปรับ</div>
          และค่าปรับอาญา จากการทำผิดกฎหมาย
        </div>
        <chevron-right-link
          @clickLink="goToFineDetail"
          caption="รายละเอียดค่าปรับต่างๆ"
          style="margin: 15px 0 0 0; justify-content: center"
        />
      </div>
      <div slot="footer" class="footer-modal">
        <material-button
          class="ptcb-button button-secondary btn-size"
          @clickButton="closeModal"
        >
          ปิด
        </material-button>
      </div>
    </modal>
  </div>
</template>

<script>
import CORP from "@/assets/images/questions/person_type-corp.png";

import SocialSharing from "@/components/common/SocialSharing.vue";
import isEmail from "validator/lib/isEmail";
import VECTOR from "@/assets/images/vector-alert.png";
import CARLENDAR from "@/assets/images/calendar";
import CALENDARINDEX from "@/assets/images/calendar-index.png";
import BUILDING from "@/assets/images/building-regular.png";
import NOTEBOOK from "@/assets/images/notebook.png";
import EXTERNALICON from "@/assets/icons/external.svg";

export default {
  name: "TemplateCorporation",
  components: {
    "social-sharing": SocialSharing,
  },
  props: {
    fact: Array,
    penalty: Array,
    showModal: { type: Boolean, default: false },
    showBusiness: { type: Boolean, default: true },
    hasFinalTaxType: Boolean,
    pathName: String,
  },
  data() {
    const { corporation } = this.$store.getters["taxInfo/taxComparationInfo"];
    return {
      corpPNG: CORP,
      email: null,
      captureOutput: null,
      VECTOR,
      CARLENDAR,
      CALENDARINDEX,
      BUILDING,
      NOTEBOOK,
      tax: corporation.tax.toLocaleString("th-TH"),
      isOpenModal: this.showModal,
      sending: false,
      EXTERNALICON,
    };
  },
  computed: {
    isEmailValid() {
      return this.email ? isEmail(this.email) : false;
    },
  },
  mounted() {
    this.capture();
  },
  methods: {
    playAgain() {
      this.$router.push({
        path: "/questions/person_type",
      });
    },
    goERegist() {
      window.open(
        "https://ereg.dbd.go.th/ERegistMemberWeb/nonmemberpages/home.xhtml",
        "_blank"
      );
    },
    closeModal() {
      this.isOpenModal = false;
    },
    async capture() {
      const el = this.$refs.captureMe;
      const options = {
        windowWidth: "1120px",
      };
      const $stickyBtn = document.getElementById("sticky-btn");
      const tempStyle = $stickyBtn ? $stickyBtn.style : undefined;
      if ($stickyBtn) {
        $stickyBtn.style = "position: relative";
      }
      const canvas = await this.$html2canvas(el, options);
      if ($stickyBtn) {
        $stickyBtn.style = tempStyle;
      }

      await canvas.toBlob((blob) => {
        this.captureOutput = blob;
      });
    },
    goToFineDetail() {
      this.$router.push({
        path: "/info/fine_detail",
      });
    },
    goDocumentsCorp() {
      this.$router.push({
        path: "/info/documents_corp",
      });
    },
    goIncome() {
      this.$router.push({ path: "/forms/income" });
    },
    goRateUs() {
      this.$router.push({
        name: "RateUs",
        params: { prevPath: "/summaries/personal_registered_goods_with_vat" },
      });
    },
    goToFags() {
      this.$router.push({
        path: "/info/faqs",
      });
    },
    async sendResultToEmail() {
      this.sending = true;
      let payload = {
        receiver: this.email,
        pathName: this.pathName,
      };
      await this.$store.dispatch("email/sendEmail", payload);
      if (!this.$store.state.email.error) {
        this.$router.push({
          name: "EmailSuccess",
        });
      }

      this.sending = false;
    },
  },
};
</script>

<style scoped>
.template-corporation {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.body-capture {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.sr2-wrap-back-btn {
  max-width: 355px;
  width: 100%;
}
.sr2-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 355px;
  text-align: center;
  position: relative;
  /* margin-bottom: 100px; */
  margin-bottom: 32px;
}
.title {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #acb1bf;
  margin-bottom: 16px;
  margin-top: 40px;
}
.sr2-knowledge {
  display: flex;
  max-width: 350px;
  border: 1px solid #99d6f1;
  height: 104px;
  border-radius: 5px;
}
.row-content-knowledge,
.wrap-btn {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-width: 351px;
  width: 100%;
}
.wrap-btn {
  margin-top: 16px;
}
.content-knowledge {
  display: flex;
  flex-direction: column;
  max-width: 351px;
  margin-bottom: 40px;
}
.img-title {
  margin-right: 8px;
}
.col-img {
  background: #99d6f1;
  width: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.col-content-knowledge {
  width: 299px;
  font-size: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.crll-img {
  margin-left: 5px;
  height: 16px;
}
.crll-img-time-line {
  margin-left: 8px;
  height: 16px;
  margin-top: 3px;
}
.cck-detail {
  text-align: left;
  width: 100%;
}
.cck-detail > span {
  font-weight: bold;
}
.sr2bb-img {
  height: 134px;
  border-radius: 5px;
}
.sr2b-body {
  display: flex;
  flex-direction: column;
}
.sr2b-body > div {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 355px;
}

.sr2bbbw-title {
  font-weight: bold;
  margin-bottom: 20px;
  border-radius: 5px;
  font-size: 19px;
  min-width: 127px;
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 35px;
}
.with-link {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.underline {
  color: #29a9e2;
  text-decoration: underline;
  cursor: pointer;
}

.sr2-body .underline {
  display: flex;
}
.calendar-card {
  background: #eff1f5;
  display: flex;
  border-radius: 5px;
  max-width: 352px;
  width: 100%;
  margin-bottom: 16px;
}
.calendar-img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.calendar-detail {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.wr-detail {
  text-align: left;
}
.wrd-subtitle {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 8px;
}
.sr2-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 351px;
}
.sr2f-row {
  display: flex;
  align-items: center;
  color: #393d43;
  margin-bottom: 8px;
}
.sr2-footer-blue {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sr2-blue-background {
  background: #99d6f133;
}
.sr2fb-body {
  width: 100%;
  max-width: 356px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 23px;
  margin-bottom: 26px;
}
.sr2fbb-form {
  margin-top: 8px;
  display: flex;
}
.sr2fbbf-input {
  height: 24px;
  width: 249px;
  padding: 15px 16px;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #acb1bf;
}
.sr2fbbf-input::placeholder {
  font-size: 17px;
  color: #acb1bf;
}
.sr2fbbf-button {
  width: 75px;
  border-radius: 0px 5px 5px 0px;
}

.contents {
  display: flex;
}
.contents span:first-child {
  margin-right: 3px;
}
.contents span:last-child {
  margin-bottom: 16px;
}
.bold {
  font-weight: bold;
}
.active {
  display: none;
}
.penalty {
  color: #f45a49;
}
.tax-lable {
  color: #9bcc55;
  font-weight: bold;
  font-size: 17px;
}
.tax-lable > div {
  margin-top: 16px;
}
.red-modal {
  color: #f45a49;
  font-weight: bold;
  font-size: 23px;
}
.btn-size {
  max-width: 350px;
}
.footer-modal {
  align-items: center;
  display: flex;
  justify-content: center;
}
.right {
  width: 100%;
}
.summary-tax {
  color: #9bcc55;
  font-weight: bold;
  margin-top: 24px;
}
.sticky-button {
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  background: #eff1f5;
  align-items: center;
  flex-direction: column;
}
.label-btn-sticky {
  font-size: 12px;
  color: #008fc1;
  margin: 8px 0;
}
.btn-sticky {
  max-width: 352px;
}
.btn-sticky:hover {
  font-weight: normal;
}
@media only screen and (min-width: 769px) {
  .row-content-knowledge,
  .content-knowledge,
  .sr2-footer {
    max-width: 1120px;
    width: 100%;
  }
  .wrap-btn button {
    max-width: 352px;
  }
  .link-desktop {
    justify-content: flex-end;
  }
  .title {
    max-width: 1120px;
    justify-content: center;
    margin-bottom: 40px;
  }
  .title br {
    display: none;
  }
  .sr2-wrap-back-btn {
    max-width: 1120px;
  }
  .sr2b-body {
    flex-direction: row;
    max-width: 810px;
    width: 100%;
  }
  .sr2b-body > div,
  .calendar-card {
    max-width: unset;
  }
  .sr2b-body > div:first-child {
    margin-right: 40px;
  }
  .sr2bb-block {
    max-width: 450px;
  }

  .sr2-footer .content-knowledge,
  .sr2-footer {
    align-items: center;
  }
  .desktop-size {
    width: unset !important;
  }
  .cck-detail br {
    display: none;
  }
  .sr2-knowledge {
    height: unset;
  }
  .sr2-knowledge .col-content-knowledge {
    margin: 15px 20px;
    width: auto;
  }
  .sr2-body {
    max-width: 1120px;
  }
  .cck-detail {
    max-width: initial;
  }
  .sr2-knowledge {
    max-width: 1120px;
  }
  .footer-modal {
    margin-bottom: 37px;
  }
  .contents {
    padding: 0 20px;
  }
  .desktop-padding {
    padding: 0 20px;
  }
  .label-btn-sticky {
    font-size: 17px;
    margin: 16px 0;
  }
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .sr2fbbf-input {
    width: 436px;
  }
}
</style>
